﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:ForecastOptionsController
 * @description
 * # ForecastOptionsController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ForecastOptionsController', ['$scope', '$rootScope', '$q', '$location', 'Utils', 'ForecastService', 'FlashService', 'ForecastingFiltersProvider',
      function ($scope, $rootScope, $q, $location, Utils, ForecastService, FlashService, ForecastingFiltersProvider) {

      $scope.periodDateRangeCluetip = 'The end date is how far forward the system generated activities. This is determined by the Rolling Days in the System Preferences when the schedule was generated.';
      $scope.weeklyDisplayCluetip = "You will only be able to view up to 7 days at a time while forecasting. Select Rolling Days if you wish to view 7 days at a time starting from today’s date. Select Calendar Days if you wish to view up to 7 days at a time in the Sunday to Saturday format.";
      $scope.model = { options: [] };
      $scope.btnSettings = { buttonDefaultText: 'Select Forecast Scope' };

      $scope.multiSelectSettings = {
          displayProp: 'value',
          attachDisplayProp: true,
          smartButtonMaxItems: 10,
          scrollableHeight: '200px',
          enableSearch: true
      };

      $scope.multiSelectEvents = {
          onItemSelect: function () {
              $scope.changed = true;
          },
          onItemDeselect: function () {
              $scope.changed = true;
          },
          onDeselectAll: function () {
              $scope.changed = true;
          }
      };

      $scope.setScope = function () {
          if (!$scope.model.forecastView) {
              return;
          }
          $scope.scopeOptions = parseInt($scope.model.forecastView) === 0 ? $scope.options.forecastScopeArea : $scope.options.forecastScopeFacility;
          $scope.model.options = [];
      };

      $scope.saveOptions = function (form) {
          if ($scope.model.options.length > 0) {
              $scope.scopeValidation = true;
          }
          else {
              $scope.scopeValidation = false;

              return;
          }

          var data = {};
          data.forecastView = parseInt($scope.model.forecastView);
          data.weeklyDisplay = $scope.model.weeklyDisplay;
          data.testScenariosOnly = $scope.model.testScenariosOnly;
          data.forecastScope = [];
          $scope.model.options.forEach(function (selected) {
              $scope.scopeOptions.forEach(function (item) {
                  if (item.id === selected.id) {
                      data.forecastScope.push(item);
                  }
              });
          });
          ForecastService.SetForecastOptions(data).then(function () {
              ForecastService.SetForecastHeader(data);
              $scope.isForecastCreated = true;
              $scope.changed = false;
              $scope.modelCopy = angular.copy($scope.model);
              form.$setPristine();
              $scope.navigateToCurrentForecast();
          });
      };

      $scope.cancel = function (form) {
          $scope.model = angular.copy($scope.modelCopy);
          form.$setPristine();
          $scope.changed = false;
      };

      $scope.navigateToCurrentForecast = function () {
          $location.path('currentForecast');
      };

      $scope.navigateToScenario = function (id) {
          $location.path('/forecastScenario/' + id);
      };

      $scope.weeklyDisplayChanged = function () {
          sessionStorage.week = null;
      };

      function getHeader() {
          var deferred = $q.defer();

          var reloadHeader = sessionStorage.reloadHeader ? true : false;
          sessionStorage.reloadHeader = '';

          ForecastService.GetForecastHeader(reloadHeader).then(function (result) {
              $scope.header = result.data;
              if (result.data.isForecastOptions) {
                  $scope.model.options = result.data.forecastOptionsSummary.forecastScope.map(function (item) { return {id: item.id.trim()}; });
                  $scope.model.forecastView = result.data.forecastOptionsSummary.forecastView.toString();
                  $scope.model.weeklyDisplay = result.data.forecastOptionsSummary.weeklyDisplay.toString();
                  $scope.model.testScenariosOnly = result.data.forecastOptionsSummary.testScenariosOnly;

                  $scope.isForecastCreated = true;
              }
              else {
                  showOptionsDialog();
              }

              if ($scope.header.openedScenarios && $scope.header.openedScenarios.length > 0) {

                  var scenarioFromSessionStorage = $scope.header.openedScenarios.firstOrDefault(function (scenario) {
                      return scenario.id === parseInt(sessionStorage.scenarioId);
                  }); 

                  $scope.selectedScenario = scenarioFromSessionStorage || $scope.header.openedScenarios[0];
              }

              deferred.resolve();
          });

          return deferred.promise;
      }

      function getOptions() {
          var deferred = $q.defer();
          ForecastService.GetForecastOptions().then(function (result) {
              $scope.options = result.data;
              if (!Utils.IsNull($scope.model.forecastView)) {
                  $scope.scopeOptions = parseInt($scope.model.forecastView) === 0 ? $scope.options.forecastScopeArea : $scope.options.forecastScopeFacility;
              }
              deferred.resolve();
          });

          return deferred.promise;
      }

      $scope.hasOpenedScenarios = function () {
          return $scope.header.openedScenarios && $scope.header.openedScenarios.length > 0;
      };

      $scope.isChanged = function () {
          return $scope.changed ||
                 $scope.modelCopy.testScenariosOnly !== $scope.model.testScenariosOnly;
                 
      };

      function initData() {
          $q.when(getHeader()).then(function () {
              $q.when(getOptions()).then(function () {
                  $scope.modelCopy = angular.copy($scope.model);
                  $scope.dataLoaded = true;
              });
          });

          ForecastingFiltersProvider.LoadFilters();
      }

      function showOptionsDialog() {
          if ($scope.isForecastCreated !== true) {
              FlashService.Alert('Please fill required fields to begin Forecasting', 'Welcome to Forecasting', 'dismiss');
          }
      }

      $scope.$on('$routeChangeStart', function (event, next) {

          if (next.originalPath && next.originalPath.indexOf('currentForecast') === -1 && next.originalPath.indexOf('forecastScenario') === -1) {
              ForecastService.Dispose();
              ForecastingFiltersProvider.Dispose();
          }
      });

      initData();
  }]);